import React, { useContext, useEffect, useState } from 'react';
import { BRANCH, serverUrl } from '../../Constant/Static/config';
import axios from 'axios';
import { AuthContext } from '../../Auth/AuthContext';
import arrowUp from '../../Constant/Icons/ArrowUp.svg';
import deleteIcon from '../../Constant/Icons/delete.svg';
import arrowDown from '../../Constant/Icons/ArrowDown.svg';
import Loader from '../../Constant/Custom/Loader';
import PopModal from '../../Constant/Custom/Models/PopModal';
import { useLocation } from 'react-router-dom';

function SelectedChoices({ handlePrevious, handleNext }) {

  const { auth } = useContext(AuthContext);
  const storedUser = auth.user;
  const [selectedChoices, setSelectedChoices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [csrfToken, setCsrfToken] = useState('');
  const [isDragEnabled, setIsDragEnabled] = useState(false);
  const [pendingLockConfirm, setPendingLockConfirm] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ icon: '', title: '', text: '' });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [onCancel, setOnCancel] = useState(() => () => { });
  const [pendingAction, setPendingAction] = useState(null);
  const [pendingDrag, setPendingDrag] = useState(null);

  useEffect(() => {
    const fetchCsrfToken = async () => {

      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, { withCredentials: true });
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };
    fetchCsrfToken();
  }, []);

  const confirmActionModal = (action, index, collCode, branch) => {
    let message = '';
    if (action === 'del') {
      message = 'Do you really want to delete this choice?';
    } else if (action === 'up') {
      message = 'Do you want to move this choice up?';
    } else if (action === 'down') {
      message = 'Do you want to move this choice down?';
    } else {
      return;
    }

    // Show initial confirmation modal
    setModalType({
      icon: 'warning',
      title: 'Confirm Action',
      text: message,
    });
    setModalType({
      icon: 'warning',
      title: 'Confirm Action',
      text: message,
    });
    setShowCancelButton(true);
    setPendingAction({ action, index, collCode, branch });
    setOnConfirm(() => async () => {
      setIsModalOpen(false)
      setIsLoading(true)
      await moveChoice(action, index, collCode, branch);
      let successText = '';
      if (action === 'del') {
        successText = 'Your Choice is Deleted successfully.';
      } else if (action === 'up') {
        successText = 'Your Choice is Moved up successfully.';
      } else if (action === 'down') {
        successText = 'Your Choice is Moved down successfully.';
      }
      setIsLoading(false)
      setIsModalOpen(true)
      setModalType({
        icon: 'success',
        title: 'Success',
        text: successText,
      });
      setShowCancelButton(false);
      setOnConfirm(() => closeModal);
    });
    setOnCancel(() => closeModal);
    openModal();
  };
  const handleAddNewChoices = () => {
    handlePrevious();
  }

  const openModal = () => setIsModalOpen(true);

  const closeModal = () => {
    setIsModalOpen(false);
    setShowCancelButton(false);
    setPendingAction(null);
    setPendingDrag(null);
    if (pendingLockConfirm) {
      // switchToLockChoiceTab('lockChoices');
      // activechoicelock('lockChoices')
      setPendingLockConfirm(false);
    }
  };

  const retrieveChoices = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const encryptedData = btoa(JSON.stringify({ storedUser }));
      const response = await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/selectedChoices`,
        { data: encryptedData },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );
      setSelectedChoices(response.data.choices);


    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  const dragDrop = async (action, dragIndex, dropIndex) => {
    if (action === 'move' && (dropIndex < 0 || dropIndex >= selectedChoices.length)) return;

    setIsLoading(true);
    setError(null);

    try {
      const payload = { storedUser, action, dragIndex, dropIndex };
      const encryptedData = btoa(JSON.stringify(payload));
      const response = await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/updateChoice`,
        { data: encryptedData },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken
          },
          withCredentials: true
        }
      );
      // console.log(response);
      // setSelectedChoices(response.data.choices);
    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  }

  const moveChoice = async (action, index, collCode, branch) => {
    if (action !== 'up' && action !== 'down' && action !== 'del') return;
    if (index < 0 || index >= selectedChoices.length) return;

    const updatedChoices = [...selectedChoices];
    if (action === 'up' && index > 0) {
      const temp = updatedChoices[index - 1];
      updatedChoices[index - 1] = updatedChoices[index];
      updatedChoices[index] = temp;
    } else if (action === 'down' && index < updatedChoices.length - 1) {
      const temp = updatedChoices[index + 1];
      updatedChoices[index + 1] = updatedChoices[index];
      updatedChoices[index] = temp;
    } else if (action === 'del') {
      updatedChoices.splice(index, 1);
    } else {
      return;
    }

    setSelectedChoices(updatedChoices);

    // setIsLoading(true);
    setError(null);

    try {
      const payload = { storedUser, action };
      payload.collCode = collCode;
      payload.branch = branch;

      const encryptedData = btoa(JSON.stringify(payload));
      const response = await axios.post(
        `${serverUrl}/api/choicefilling/user/choices/moveChoice`,
        { data: encryptedData },
        {
          headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': csrfToken
          },
          withCredentials: true
        }
      );
      // console.log(response);
      // setSelectedChoices(response.data.choices);
    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!csrfToken) return;
    retrieveChoices();
  }, [csrfToken]);

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('index', index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const confirmDragMove = (dragIndex, dropIndex) => {
    const updatedChoices = [...selectedChoices];
    const [draggedChoice] = updatedChoices.splice(dragIndex, 1);
    updatedChoices.splice(dropIndex, 0, draggedChoice);
    setSelectedChoices(updatedChoices);
    dragDrop('move', dragIndex, dropIndex);
    closeModal();
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = parseInt(e.dataTransfer.getData('index'), 10);
    if (dragIndex === dropIndex || isNaN(dragIndex) || !isDragEnabled) return;
    setPendingDrag({ dragIndex, dropIndex });
    setModalType({
      icon: 'info',
      title: 'Confirm Move',
      text: `Do you want to move your choice to Position <b style="font-weight:900">${dropIndex + 1}</b> ?`,
    });
    setShowCancelButton(true);
    setOnConfirm(() => () => confirmDragMove(dragIndex, dropIndex));
    setOnCancel(() => closeModal);
    openModal();
  };

  const handleLockChoiceClick = () => {
    if (selectedChoices.length > 0) {
      handleNext()
      // setPendingLockConfirm(true);
      // setModalType({
      //   icon: 'info',
      //   title: 'Confirm Lock Choices',
      //   text: 'Are you sure you want to lock your choices? This action cannot be undone.',
      // });
      // setShowCancelButton(true);
      // setOnConfirm(() => () => {
      //   closeModal();
      // });
      // setOnCancel(() => closeModal);
      // openModal();
    } else {
      setModalType({
        icon: 'warning',
        title: 'Warning',
        text: 'Please Select at Least One College to Lock the Choices.',
      });
      setPendingLockConfirm(false);
      setOnConfirm(() => closeModal);
      openModal();
    }
  };
  if (isLoading) {
    return (<Loader />)
  }

  return (
    <>

      {error && <div className="error">{error}</div>}




      <div className="choice-table-container">

        <div className="choice-nav-buttons">
          <button className="nav-btn left" onClick={handleAddNewChoices}>Add Choices</button>
          <h1>Selected Choices</h1>
          <button className="nav-btn right" onClick={handleLockChoiceClick}>Go to Lock Choices</button>
        </div>
        <div>
          <h3 style={{ textAlign: "center", color: 'red' }}>Kindly check your choice selection order and lock your choices</h3>
          <h3 style={{ textAlign: "center", color: 'red' }}>தயவு செய்து தங்கள் தேர்வுகளை சரிபார்த்த பின்னர் உங்களின் தேர்வுகளை உறுதி செய்யவும்</h3>
        </div>
        {
          selectedChoices.length > 0 && (
            <div className="toggle-drag-container">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isDragEnabled}
                  onChange={() => setIsDragEnabled(!isDragEnabled)}
                />
                <span className="slider"></span>
                <span className="toggle-label">
                  {isDragEnabled ? 'Drag and Drop Enabled' : 'Enable Drag'}
                </span>
                <div style={{display:'flex',justifyContent:'flex-end',flexDirection:'row'}}>

                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Applicant Name : <b>{storedUser.userName}</b></p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Application Number : <b>{storedUser.appno}</b></p>
                </div>
              </label>
            </div>
          )
        }
        {selectedChoices && selectedChoices.length > 0 ? (
          <table className="choice-responsive-table">
            <thead>
              <tr>
                <th>S No.</th>
                <th>Move To(Drag)</th>
                <th>College Code</th>
                <th>Institution Name</th>
                <th>Branch</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {selectedChoices.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td
                    draggable={isDragEnabled}
                    onDragStart={isDragEnabled ? (e) => handleDragStart(e, index) : undefined}
                    onDragOver={isDragEnabled ? handleDragOver : undefined}
                    onDrop={isDragEnabled ? (e) => handleDrop(e, index) : undefined}
                    style={{
                      backgroundColor: isDragEnabled ? 'transparent' : '	#E0E0E0',
                      cursor: isDragEnabled ? 'grab' : 'not-allowed'
                    }}
                  >
                    <span
                      className="dragger-icon"
                      aria-label={`Drag to reorder choice ${row.COLL_CODE} - ${BRANCH.get(row.BRANCH)}`}
                    >
                      ⋮⋮
                    </span>
                  </td>
                  <td>{row.COLL_CODE}</td>
                  <td>{row.INSTITUTION}</td>
                  <td>{BRANCH.get(row.BRANCH)}</td>
                  <td>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                      <button
                        className="btn"
                        onClick={() => confirmActionModal('up', index, row.COLL_CODE, row.BRANCH)}
                        disabled={index === 0}
                      >
                        <img src={arrowUp} alt="Move Up" width={25} height={25} />
                      </button>
                      <button
                        className="btn"
                        onClick={() => confirmActionModal('down', index, row.COLL_CODE, row.BRANCH)}
                        disabled={index === selectedChoices.length - 1}
                      >
                        <img src={arrowDown} alt="Move Down" width={25} height={25} />
                      </button>
                      <button
                        className="btn"
                        onClick={() => confirmActionModal('del', index, row.COLL_CODE, row.BRANCH)}
                      >
                        <img src={deleteIcon} alt="Delete" width={25} height={25} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <h2 style={{ textAlign: 'center', marginTop: '20px', color: 'red' }}>
            Please Select Atleast a Single College To Lock The Choices
          </h2>
        )}


      </div>
      <PopModal
        isOpen={isModalOpen}
        type={modalType}
        confirmButtonText="Yes"
        cancelButtonText="No"
        onConfirm={onConfirm}
        onCancel={showCancelButton ? onCancel : null}
        showCancelButton={showCancelButton}
      />
    </>
  );
}

export default SelectedChoices;